import { render, staticRenderFns } from "./IPTacceptOrReject.vue?vue&type=template&id=3028b254&scoped=true&"
import script from "./IPTacceptOrReject.vue?vue&type=script&lang=ts&"
export * from "./IPTacceptOrReject.vue?vue&type=script&lang=ts&"
import style0 from "./IPTacceptOrReject.vue?vue&type=style&index=0&id=3028b254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3028b254",
  null
  
)

export default component.exports